/* eslint-disable no-unused-expressions */
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {
    PageWrapper,
    BackgroundImage,
    FormWrapper,
    InputWrapper,
    InputsWrapper,
    BackgroundImageOverlay,
    Card,
    SizeInputs,
    ErrorMessage,
    InputTitle,
    Section,
    Tooltip,
    TooltipDesc, NoReservationHeader, StillInterested, LoginWrapper
} from "./ReservationInputs.style";
import {Title, Subtitle, MainButton, InputField, Select, DateRangePicker } from '../../../../components/common';
import {
    selectEnableBackground,
    selectMarina,
    selectMarinaData,
    selectRedirectUrl, selectRedirectUrlProvided,
    selectIframe
} from "../../../../store/slices/app/selectors";
import {PoweredByPickapier} from "../PoweredByPickapier";
import {VesselType, Units, HullType, NatureOfTravel} from "../../../../settings/enums";
import {getInitialInquiryValidationSchema, validateEmail, getBeforeApprovalValidationSchema, getDocumentsValidationSchema} from "../../../../utils/validations";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import {
    selectForceLogin,
    selectHullType, selectIsNewVessel, selectNatureOfTravel, selectPromotions, selectReservationDetails,
    selectReservationEndDate,
    selectReservationProposal,
    selectReservationStartDate, selectUnits, selectVesselBeam, selectVesselDraft, selectVesselLength, selectVesselType,
    selectError,
    selectIsRequest,
    selectVessel,
    selectCalculatedPrice
} from "../../../../store/slices/reservation/selectors";
import {ReservationRoutes as Routes} from "../../routes";
import {InstantBookingSideStamp} from "../../components/InstantBookingSideStamp";
import {ReservationSuccessDialog} from "../../components/ReservationSuccessDialog";
import {format2Decimals} from "../../../../utils/format";
import AvailableBerthsBox from "../../components/AvailableBerthsBox/AvailableBerthsBox";
import {Login, LoginDialog} from "../Login";
import {SessionEndedDialog} from "../../components/SessionEndedDialog";
import {InstantBookingRequirement} from '../../../../settings/enums';
import { ReservationRequirementsBeforeApproval } from "settings/enums/reservation_before_approval_requirements";
import {ReservationFailureDialog} from "../ReservationFailureDialog";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import {AuthContext} from "../../../../context/AuthProvider";
import i18n from "../../../../i18n";
import InfoCircleFilled from "@ant-design/icons/InfoCircleFilled";
import {sanitizeTranslation} from "../../../../library/helpers/translationHelpers";
import {ReactSVG} from "react-svg";
import messageIcon from "../../../../assets/images/pickapier/chat-bubble-outline.svg";
import {MESSAGES_PAGE} from "../../../../settings/constant";
import {InputLabel, Row} from "../ReservationForm/styles";
import useReservationCalculator from "../../../SinglePage/Reservation/useReservationCalculator";
import countries  from 'utils/countries';
import { docTypes } from "container/Agent/Reservation/ReservationPage";
import isEmpty from 'lodash/isEmpty';
import {RedeemNightsExceeded} from "../../../SinglePage/Reservation/Reservation.style";
import { isMobile } from 'react-device-detect';
import { generateID } from "library/helpers/utils";
import HomeMarinaSelect from "container/SinglePage/Reservation/homeMarinaSelect";
import useReservationInputsMainButton from "./useReservationInputsMainButton";

const SESSION_TIMEOUT = process.env.REACT_APP_SESSION_TIMEOUT_MINUTES ?
    parseFloat(process.env.REACT_APP_SESSION_TIMEOUT_MINUTES) : 10;

const ReservationInputs = () => {
    const { loggedIn, user: boater, selectBoaterVessel, selectedBoaterVessel } = useContext(AuthContext);
    const redirectUrl = useSelector(selectRedirectUrl);
    const redirectUrlProvided = useSelector(selectRedirectUrlProvided);
    const marina = useSelector(selectMarina);
    const isIframe = useSelector(selectIframe);
    const marinaData = useSelector(selectMarinaData);
    const proposal = useSelector(selectReservationProposal);
    const storeStartDate = useSelector(selectReservationStartDate);
    const storeEndDate = useSelector(selectReservationEndDate);
    const storeUnits = useSelector(selectUnits);
    const storeLoa = useSelector(selectVesselLength);
    const storeBeam = useSelector(selectVesselBeam);
    const storeDraft = useSelector(selectVesselDraft);
    const storeVesselType = useSelector(selectVesselType);
    const storeHullType = useSelector(selectHullType);
    const storeNatureOfTravel = useSelector(selectNatureOfTravel);
    const reservationDetails = useSelector(selectReservationDetails);
    const isRequest = useSelector(selectIsRequest);
    const forceLogin = useSelector(selectForceLogin);
    const enableBackground = useSelector(selectEnableBackground);
    const isNewVessel = useSelector(selectIsNewVessel);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [email, setEmail] = useState('' || boater?.email);
    const [boatName, setBoatName] = useState(undefined);
    const [boatNameTouched, setBoatNameTouched] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailTouched, setEmailTouched] = useState(false);
    const [tooLate, setTooLate] = useState(false);
    const [contract, setContract] = useState('');

    const [editStartDate, setEditStartDate] = useState(true)
    const [editEndDate, setEditEndDate] = useState(true)
    const [contracts, setContracts] = useState( marina?.marina_settings?.permissions.long_term_contracts
                                                ? marina?.season_pricing_plans?.filter((pricingPlan) => pricingPlan.isContract === true)
                                                : [])
    const [focusOnFirst, setFocusOnFirst] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [bookingRequestSubmitted, setBookingRequestSubmitted] = useState(false);
    const [expired, setExpired] = useState(false);
    const [requestEmail, setRequestEmail] = useState(false);
    const loaRef = useRef();
    const beamRef = useRef();
    const draftRef = useRef();
    const vesselTypeRef = useRef();
    const hullTypeRef = useRef();
    const homeMarinaRef = useRef();
    const countryRef = useRef();
    const redeemNightsRef = useRef();
    const notRef = useRef();
    const vesselRef = useRef (null);
    const contractIdRef = useRef();
    const [isReservationsDisabled, setIsReservationDisabled] = useState(marina && !(marina?.marina_settings?.permissions?.reservation));
    const isInstantBookingEnabled = !isReservationsDisabled && !!marina?.marina_settings?.permissions?.instant_booking;
    const [short_long, set_short_long] = useState('short');
    const [emptyFields, setEmptyFields] = useState([{hull_type: false, type:false}]);
    const [periodSelected, setPeriodSelected] = useState(false);
    const shortTermPlansLength = marina?.season_pricing_plans?.filter((pricingPlan) => pricingPlan.isContract !== true).length;
    const reservationError = useSelector(selectError);
    const calculatedPriceForOffline = useSelector(selectCalculatedPrice);
    const [offline, setOffline] = useState(false);
    const selectedVessel = useSelector(selectVessel);
    const [vessel_license, set_vessel_license] = useState(null)
    const [vessel_photo, set_vessel_photo] = useState(null)
    const [vessel_insurance, set_vessel_insurance] = useState(null)
    const [skiper_id, set_skiper_id] = useState(null)

    const isTEMMarina = marina.association.code === 'TEM';

    const {vesselsWithHomeMarina, isHomeMarina } = useMemo(() => {
        const _vesselsWithHomeMarina = boater && boater.vessels && boater.vessels.length
            ? boater.vessels.filter(v => v.home_marina_id)
            : [];
        const _isHomeMarina = _vesselsWithHomeMarina.some(
            ({ home_marina_id }) => home_marina_id === marina.id
        );
        return {vesselsWithHomeMarina: _vesselsWithHomeMarina , isHomeMarina: _isHomeMarina}
    }, [boater]);

    useEffect(() => {
        if(loggedIn) {
            dispatch(reservationActions.setIsNewVessel(true));
            dispatch(reservationActions.setIsLoggedInStep1(true));
        }
    }, [loggedIn]);

    useEffect(() => {
        // Disable reservation if no short term plans and no long term contracts
        if (!shortTermPlansLength && !contracts.length) {
          setIsReservationDisabled(true);
        }

        // Determine contract type based on availability
        if (contracts?.length === 0  && shortTermPlansLength > 0) {
            setContract('SHORT_TERM');
        } else if (!shortTermPlansLength && contracts?.length > 0) {
            setContract('LONG');
        }

        // Sort contracts by length if there are contracts
        if (contracts?.length > 0) {
          setContracts(sortByLength([...contracts]));
        }
      }, [marina]);


    useEffect(() => {
        if (focusOnFirst) {
            setSubmitted(true);
        }
    }, [focusOnFirst]);

    useEffect(() =>{
        const newShortLong = (contract === 'SHORT_TERM' || contract === '') ? 'short' : 'long';
        set_short_long(newShortLong);
    },[contract])

    useEffect(() => {
        if (proposal?.price?.count_descriptions === 'RESERVATION_IS_NOT_COVERED_IN_THE_MARINA_SEASONS') {
            setOffline(true);
        }
    }, [proposal]);


    const limits = useMemo(() => {
        let max_days_before = marina?.marina_settings?.reservation_limits?.[short_long]['max_days_before'];
        max_days_before = max_days_before? parseInt(max_days_before) : null;

        let max_days_before_offline = marina?.marina_settings?.reservation_limits?.[short_long]['instant_booking_max_days_before'];
        max_days_before_offline = (isInstantBookingEnabled && max_days_before_offline)? parseInt(max_days_before_offline) : null;

        let min_days_before = marina?.marina_settings?.reservation_limits?.[short_long]['instant_booking_min_days_before' ];
        min_days_before = (isInstantBookingEnabled && min_days_before) ? parseInt(min_days_before) : null;

        let max_nights = marina?.marina_settings?.reservation_limits?.['short'][ 'max_nights'];
        max_nights = (max_nights && short_long === 'short')? parseInt(max_nights): null;

        let max_nights_offline = marina?.marina_settings?.reservation_limits?.[short_long]['instant_booking_max_nights'];
        max_nights_offline = max_nights_offline? parseInt(max_nights_offline): null;



        const offlineLimits={
            max_nights_offline,
            max_days_before_offline

        }

        const pickerLimits = {
            max_days_before,
            min_days_before,
            max_nights
        }
        const vesselSizeLimits = {
            max_vessel_length: parseInt(marina?.marina_settings?.reservation_limits?.[short_long]['max_vessel_length']) || 250,
            max_vessel_beam: parseInt(marina?.marina_settings?.reservation_limits?.[short_long]['max_vessel_beam']) || 40,
            max_vessel_draft: parseInt(marina?.marina_settings?.reservation_limits?.[short_long]['max_vessel_draft']) || 20
        };
            return {pickerLimits, vesselSizeLimits, offlineLimits}
        }, [ short_long, marina?.marina_settings?.reservation_limits, isInstantBookingEnabled ]);

    const { eligibleVesselsForMarina } = useMemo(() => {
        const _eligibleVesselsForMarina = boater && boater.vessels && boater.vessels.length
            ? boater.vessels.filter((vessel) => {
                return (
                    vessel.home_marina_name !== marina?.name &&
                    parseInt(vessel.length) <= limits.vesselSizeLimits.max_vessel_length &&
                    parseInt(vessel.beam) <= limits.vesselSizeLimits.max_vessel_beam &&
                    parseInt(vessel.draft) <= limits.vesselSizeLimits.max_vessel_draft
                );
            })
            : [];
        return { eligibleVesselsForMarina: _eligibleVesselsForMarina };
    }, [boater, limits]);

    const restrictions = useMemo(() => ({
        loa: marina?.marina_settings?.reservation_limits?.[short_long][ 'max_vessel_length'] || undefined,
        beam: marina?.marina_settings?.reservation_limits?.[short_long][ 'max_vessel_beam'] || undefined,
        draft: marina?.marina_settings?.reservation_limits?.[short_long]['max_vessel_draft'] || undefined,
        vesselType: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.VesselType),
        hullType: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.VesselHullType),
        natureOfTravel: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.PrivateOrCommercial),
        liveAboard: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.LiveAboard),
        contract: marina?.marina_settings?.permissions?.long_term_contracts && !!contracts.length,
        existingVesselName: !!( boater && eligibleVesselsForMarina?.length),
        waterElectricity:marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.WaterElectricity),
        passeportEscales: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.PasseportEscales),
        homeMarina: marina?.marina_settings?.marina_requirements?.[short_long]?.initial_inquiry?.includes(InstantBookingRequirement.HomeMarinaName),
        country:    marina?.marina_settings?.marina_requirements?.[short_long].initial_inquiry?.includes(InstantBookingRequirement.Country),
    }), [short_long, marina]);

    const requirements_before_approval = useMemo(() => ({
        vesselName: isNewVessel,
        emailAddress: !loggedIn,
        phone: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.Phone) && (!boater || (boater && !boater?.phone)),
        // dateOfBirth: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.DateOfBirth),
        address: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.Address)&& (!boater || (boater && !boater?.address)),
        postCode: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.PostalCode)&& (!boater || (boater && !boater?.postal_code)),
        country: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.CountryOfResidence)&& (!boater || (boater && !boater?.country_of_residence)),
        vesselType: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.VesselType) && (! selectedVessel || (selectedVessel && !selectedVessel.type) ),
        hullType: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.VesselHullType) && (!selectedVessel || (selectedVessel && !selectedVessel.hull_type)),
        waterElectricity: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.WaterElectricity) && (!selectedVessel || (selectedVessel && !selectedVessel.water_electricity)),
        homeMarina: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.HomeMarinaName) && (! selectedVessel || (selectedVessel && !selectedVessel.home_marina_name) ),
        vesselName: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.VesselName) && (! selectedVessel || (selectedVessel && !selectedVessel.name) ),
        firstName: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.FirstName)&& (!boater || (boater && !boater?.first_name)),
        lastName: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.LastName)&& (!boater || (boater && !boater?.last_name)),
        emailAddress: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.EmailAddress)&& (!boater || (boater && !boater?.email)),

        natureOfTravel: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.natureOfTravel),
        liveAboard: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.LiveAboard),
        vessel_license: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.License) && (!vessel_license),
        vessel_insurance: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.Insurance) && !vessel_insurance,
        skipper_id: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.SkipperId) && !skiper_id,
        vessel_photo: marina?.marina_settings?.marina_requirements?.[short_long]?.before_approval?.includes(ReservationRequirementsBeforeApproval.Photo) && !vessel_photo,
    }), [marina?.marina_settings, short_long, boater, selectedVessel, isNewVessel, loggedIn, vessel_license, vessel_insurance, skiper_id, vessel_photo]);

    const formik2 = useFormik({
        initialValues: {
            phone:  undefined,
            address:  undefined,
            postCode:   undefined,
            country:  undefined,
            vesselType:  undefined,
            hullType: undefined,
            firstName: undefined,
            lastName: undefined,
            emailAddress:  undefined,
            natureOfTravel: undefined,
            liveAboard: undefined,
            vesselName:  undefined,
            waterElectricity:  undefined,
            passeportEscales:  false,
            vessel_license: null,
            vessel_insurance: null,
            skipper_id: null,
            vessel_photo: null,
            homeMarinaId:undefined
        },
        validateOnMount: false,
        validateOnBlur: false,
        validateOnChange: true,
        validationSchema: Yup.object().shape({...getBeforeApprovalValidationSchema(t, requirements_before_approval), ...getDocumentsValidationSchema(t, requirements_before_approval)}),
        onSubmit: values => {
            let attachment_ids = []
                if (values.vessel_license && values.vessel_license.id) attachment_ids.push(values.vessel_license.id);
                if (values.vessel_insurance && values.vessel_insurance.id) attachment_ids.push(values.vessel_insurance.id);
                if (values.vessel_photo && values.vessel_photo.id) attachment_ids.push(values.vessel_photo.id);
            dispatch(reservationActions.setAttachmentIds(attachment_ids));
            sendBookingRequest();
        }

    });

    useEffect(()=>{

        if(!selectedVessel){
            return;
        }
        dispatch(reservationActions.setvesselInsuranceFile(undefined));
        dispatch(reservationActions.setvesselLicenseFile(undefined));
        dispatch(reservationActions.setvesselPhotoFile(undefined));
        set_vessel_license(null);
        set_vessel_insurance(null);
        set_vessel_photo(null);

        const vesselAttachments = selectedVessel? selectedVessel.attachments :[];


           let vesselLicense = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_license
          )[0];
           let vesselInsurance = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_insurance
          )[0];

           let vesselPhoto = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_photo
          )[0];
          if(vesselInsurance){
            set_vessel_insurance(vesselInsurance)
            formik2.setFieldValue('vessel_insurance', vesselInsurance)
          }
          if(vesselLicense){
            set_vessel_license(vesselLicense)
            formik2.setFieldValue('vessel_license', vesselLicense)
          }

          if(vesselPhoto){
            set_vessel_photo(vesselPhoto)
            formik2.setFieldValue('vessel_photo', vesselPhoto)
          }
          formik.setFieldValue('homeMarinaId', selectedVessel?.home_marina_id? selectedVessel.home_marina_id
            : selectedVessel?.home_marina_name? generateID(selectedVessel.home_marina_name) : undefined )

        },[selectedVessel])

        useEffect(()=>{
            const boaterAttachments = boater? boater.attachments :[];
            let skiperId = boaterAttachments.filter(
                a => a.attachment_type === docTypes.skipper_id
              )[0];
              if(skiperId){
                set_skiper_id(skiperId)
                dispatch(reservationActions.setskiperIdFile(undefined))
              }
        },[boater])

    useEffect(() => {
        if (boater) {
            if (boater.first_name?.length > 0) {
                formik2.setFieldValue('firstName', boater.first_name);

            }
            if (boater.last_name?.length > 0) {
                formik2.setFieldValue('lastName', boater.last_name);

            }
            if (boater.email?.length > 0) {
                formik2.setFieldValue('emailAddress', boater.email);
            }
            if(boater.phone?.length > 0) {
                formik2.setFieldValue('phone', boater.phone);
            }
            if(boater.address?.length > 0) {
                formik2.setFieldValue('address', boater.address);
            }
            if((boater.postal_code?.length || 0) > 0) {
                formik2.setFieldValue('postCode', boater.postal_code);
            }

            formik2.setFieldValue('vesselType', selectedVessel?.type  || undefined )
            formik2.setFieldValue('hullType', selectedVessel?.hull_type  || undefined )
            formik2.setFieldValue('homeMarinaId', selectedVessel?.home_marina_id? selectedVessel.home_marina_id
                : selectedVessel?.home_marina_name? generateID(selectedVessel.home_marina_name) : undefined )
            formik2.setFieldValue('vesselName', selectedVessel?.name  || undefined )
            formik2.setFieldValue('waterElectricity', selectedVessel?.water_electricity  || undefined )
        }
    }, [boater, selectedVessel]);

    const formik = useFormik({
        initialValues: {
            startDate: storeStartDate || null,
            endDate: storeEndDate || null,
            units: storeUnits || Units.METERS,
            vesselLength: storeLoa || undefined,
            vesselBeam: storeBeam || undefined,
            vesselDraft: storeDraft || undefined,
            vesselType: storeVesselType || undefined,
            hullType: storeHullType || undefined,
            natureOfTravel: storeNatureOfTravel || undefined,
            liveAboard: undefined,
            contractId: null,
            waterElectricity:undefined,
            passeportEscales: false,
            country:undefined,
            nightsToRedeem: 0,
            homeMarinaId: undefined
        },
        validateOnMount: false,
        validateOnBlur: false,
        validateOnChange: true,
        validationSchema: Yup.object().shape(getInitialInquiryValidationSchema(t, restrictions)),
        onSubmit: values => {
            const _contract = contracts?.find(c => c.id === contract)
            if(_contract && !_contract.allow_instant_booking){
                setOffline(true);
            }
            if ( limits.pickerLimits.min_days_before &&
                moment(values.startDate).startOf('day').diff(moment().startOf('day'), 'days') <
                Number( limits.pickerLimits.min_days_before )
            ) {
                setTooLate(true)
            }
            if( limits.offlineLimits.max_nights_offline && moment(values.endDate).startOf('day').diff(moment(values.startDate).startOf('day'), 'days') >
                limits.offlineLimits.max_nights_offline ){
                    setOffline(true);
                }
            if( limits.offlineLimits.max_days_before_offline && moment(values.startDate).startOf('day').diff(moment().startOf('day'), 'days') >
                limits.offlineLimits.max_days_before_offline ){
                    setOffline(true);
                }
            if (marina?.id) {
                if((!isInstantBookingEnabled && !calculatedPriceForOffline || values.passeportEscales) ){
                    getReservationPrice();
                }
                else if(isInstantBookingEnabled) {
                    dispatch(reservationActions.loadReservationProposals({
                        marina_id: marina?.id || 0,
                        start_date: values.startDate,
                        end_date: values.endDate,
                        vessel_length: values.vesselLength,
                        vessel_beam: values.vesselBeam,
                        vessel_draft: values.vesselDraft,
                        vessel_type: values.vesselType,
                        hull_type: values.hullType,
                        nature_of_travel: values.natureOfTravel,
                        live_aboard: values.liveAboard,
                        passeport_escales: values.passeportEscales,
                        contract_id: (values.contractId === 'SHORT_TERM') ? null : values.contractId,
                        requested_redeem_nights_amount: values.nightsToRedeem || 0
                        //here need to add homemarina, country, water electricity ....
                    }));
                    getReservationPrice();
                 } else {
                    //this else should not happen!
                    setRequestEmail(false);
                }
            }
        }
    });

    useEffect(() => {
        formik.submitForm();
    }, [formik.values.nightsToRedeem]);

    const isTEMConnected = useMemo(() => {
        if(!boater || formik.values.existingVesselName === 'newBoat') return false;
        const selectedVessel = boater.vessels?.find((v) => v.name === formik.values.existingVesselName);
        return !!selectedVessel?.memberships?.length
    }, [boater?.vessels, formik.values.existingVesselName]);

    const onMaxNightsToRedeemLessThanRequested = useCallback(() => {
        // TODO
    }, []);



    const {
        calculatedPrice,
        redeemNightsOptions,
        getReservationPrice // Function returned from the hook
      } = useReservationCalculator({
                        startDate: formik.values.startDate ? moment(formik.values.startDate).format('DD/MM/YYYY') : undefined,
                        endDate: formik.values.endDate ? moment(formik.values.endDate).format('DD/MM/YYYY') : undefined,
                        requestedRedeemNightsAmount: formik.values.nightsToRedeem || 0,
                        isTEMConnected,
                        marinaId: marina?.id,
                        addNew: isNewVessel,
                        nature_of_travel: formik.values.natureOfTravel,
                        live_aboard: formik.values.liveAboard,
                        contract_id: (formik.values.contractId === 'SHORT_TERM') ? null : formik.values.contractId,
                        values: {
                            hull_type: formik.values.hullType,
                            length: formik.values.vesselLength,
                            draft: formik.values.vesselDraft,
                            beam: formik.values.vesselBeam,
                            requested_redeem_nights_amount: null,
                            vessel_name: formik.values.vesselName,
                            vessel_type: formik.values.vesselType,
                        },
                        emptyVesselSelected: !formik.values.vesselLength || !formik.values.vesselDraft || !formik.values.vesselBeam || !formik.values.hullType,
                        vesselMissingDetails: {},
                        onMaxNightsToRedeemLessThanRequested
            });
    useEffect(()=>{
        if(Object.keys(calculatedPrice || {}).length > 0) dispatch(reservationActions.setCalculatedPrice(calculatedPrice))
    },[calculatedPrice])

    useEffect(() => {
        let timeout;
        if (proposal && proposal.berth_id) {
            timeout = setTimeout(() => {
                dispatch(reservationActions.setReservationProposal(undefined));
                setExpired(true);
            }, SESSION_TIMEOUT * 60 * 1000);
        }
        return () => clearTimeout(timeout);
    }, [proposal]);

    useEffect(() => {
        if (focusOnFirst) {
            if (formik.errors.startDate || formik.errors.endDate ) {
                return;
            }
            if (formik.errors.vesselLength) {
                loaRef.current?.focus();
            } else if (formik.errors.vesselBeam) {
                beamRef.current?.focus();
            } else if (formik.errors.vesselDraft) {
                draftRef.current?.focus();
            } else if (formik.errors.vesselType) {
                vesselTypeRef.current?.focus();
            } else if (formik.errors.hullType) {
                hullTypeRef.current?.focus();
            } else if (formik.errors.homeMarinaRef) {
                homeMarinaRef.current?.focus();
            }else if (formik.errors.natureOfTravel) {
                notRef.current?.focus();
            } else if (formik.errors.contractId) {
                contractIdRef.current?.focus()
            }
            setFocusOnFirst(false);
        }
    }, [formik.errors, focusOnFirst, formik.values]);

    const {
        startDate,
        endDate,
        // units,
        vesselType,
        hullType,
        natureOfTravel,
        contractId
    } = formik.values;

    const sortByLength = contracts => {
        let fixedPeriodContracts = contracts.filter(c => c.contract_type === "STARTENDDATES");
        fixedPeriodContracts.sort((a, b) => {
            return lengthInDays(a) - lengthInDays(b);
        })
        let remain = contracts.filter(c => c.contract_type !== "STARTENDDATES");
        remain.sort((a, b) => {
            return lengthInDays(a) - lengthInDays(b)
        })
        return remain.concat(fixedPeriodContracts);
    }

    const lengthInDays = contract => {

        let length = 0;
        if (contract.contract_type === "STARTENDDATES") {
            length = moment(contract.to).diff(moment(contract.from), 'days')
        } else {
            const number = parseInt((contract.contract_type.match(/^\d+/) || '0')[0]);
            if ((contract.contract_type.includes("MONTH"))) {
                length = (moment().add(number, 'months')).diff(moment(), 'days')
            }
            if (contract.contract_type.includes("YEAR")) {
                length = (moment().add(number, 'years')).diff(moment(), 'days')
            }
        }
        return length;
    }

    const onLengthChanged = length => {
        try {
            const val = length === '' ? undefined : parseFloat(length);
            if (val !== undefined && isNaN(val)) {
                return;
            }
            formik.setFieldValue('vesselLength', format2Decimals(length));
            setTooLate(false);
            if (proposal) {
                dispatch(reservationActions.clearBerthLock(proposal));
                dispatch(reservationActions.setReservationProposal(undefined));
            }
            if(calculatedPriceForOffline){
                dispatch(reservationActions.setCalculatedPrice(null));
            }
        } catch (e) {
        }
    }

    const onBeamChanged = beam => {
        try {
            const val = beam === '' ? undefined : parseFloat(beam);
            if (val !== undefined && isNaN(val)) {
                return;
            }
            formik.setFieldValue('vesselBeam', format2Decimals(beam));
            setTooLate(false);
            if (proposal) {
                dispatch(reservationActions.clearBerthLock(proposal));
                dispatch(reservationActions.setReservationProposal(undefined));
            }
            if(calculatedPriceForOffline){
                dispatch(reservationActions.setCalculatedPrice(null));
            }
        } catch (e) {
        }
    }

    const onDraftChanged = draft => {
        try {
            const val = draft === '' ? undefined : parseFloat(draft);
            if (val !== undefined && isNaN(val)) {
                return;
            }
            formik.setFieldValue('vesselDraft', format2Decimals(draft));
            setTooLate(false);
            if (proposal) {
                dispatch(reservationActions.clearBerthLock(proposal));
                dispatch(reservationActions.setReservationProposal(undefined));
            }
            if(calculatedPriceForOffline){
                dispatch(reservationActions.setCalculatedPrice(null));
            }
        } catch (e) {
        }
    }

    const onDatesChange = (dates) => {
        formik.setFieldValue('startDate', moment(dates.startDate).utc(true).valueOf() || null)
        formik.setFieldValue('endDate', moment(dates.endDate).utc(true).valueOf() || null);
        if(reservationError === 'RESERVATION_DUPLICATE_DATA'){
            dispatch(reservationActions.setReservationError(undefined));
        }
        setOffline(false);
        setTooLate(false);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
            formik2.resetForm();
            //delete files
            setBookingRequestSubmitted(false)
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onVesselTypeChange = type => {
        formik.setFieldValue('vesselType', type);
        setTooLate(false)
        setOffline(false);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onHullTypeChange = type => {
        formik.setFieldValue('hullType', type);
        setTooLate(false)
        setOffline(false);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onWaterElectricityChanged = () => {
        formik.setFieldValue('waterElectricity', !formik.values.waterElectricity);
    }

    const onPasseportEscalesChanged = () => {
        formik.setFieldValue('passeportEscales', !formik.values.passeportEscales);
        formik2.setFieldValue('passeportEscales', !formik.values.passeportEscales);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onCountryChange = country => {
        formik.setFieldValue('country', country);
    }

    const onRedeemNightsChange = nights => {
        formik.setFieldValue('nightsToRedeem', nights);
    }

    const onNatureOfTravelChange = nature => {
        formik.setFieldValue('natureOfTravel', nature);
        setTooLate(false);
        setOffline(false);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onLiveAboardChange = () => {
        formik.setFieldValue('liveAboard', !formik.values.liveAboard);
        setTooLate(false);
        setOffline(false);
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
    }

    const onPeriodChange = contract_id => {
        formik.setFieldValue('contractId', contract_id);
        const dates = {startDate: null, endDate: null}
        onDatesChange(dates);
        if(reservationError === 'RESERVATION_DUPLICATE_DATA'){
            dispatch(reservationActions.setReservationError(undefined));
        }

        const contract = contracts?.find(c => c.id === contract_id);
        if (contract_id === 'SHORT_TERM') {
            setEditEndDate(true);
            setEditStartDate(true);


        } else if (contract?.contract_type.includes("MONTH") || contract?.contract_type.includes("YEAR")) {
            setEditStartDate(true);
            setEditEndDate(false);

        } else {
            const dates = {startDate: moment(contract?.from), endDate: moment(contract?.to)}
            onDatesChange(dates)

            setEditEndDate(false);
            setEditStartDate(false);
        }
        setContract(contract_id);
        setPeriodSelected(true);

        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined))
        }
    }

    const next = useMemo(() => () => {
        dispatch(reservationActions.reserveBerth());
        history.push(`${Routes.Reservation}`);
    }, [history]);

    //check capital letter email
    useEffect(() => {
        setEmailError(!validateEmail(email));
    }, [email]);

    const sendBookingRequest = () => {

            dispatch(reservationActions.setStartDate(formik.values.startDate));
            dispatch(reservationActions.setEndDate(formik.values.endDate));
            dispatch(reservationActions.setVesselLength(formik.values.vesselLength));
            dispatch(reservationActions.setVesselBeam(formik.values.vesselBeam));
            dispatch(reservationActions.setVesselDraft(formik.values.vesselDraft));
            dispatch(reservationActions.setContractId((formik.values.contractId === 'SHORT_TERM') ? null : formik.values.contractId))

            dispatch(reservationActions.setVesselName(formik2.values.vesselName));
            dispatch(reservationActions.setVesselType(formik.values.vesselType || formik2.values.vesselType));
            dispatch(reservationActions.setHullType(formik.values.hullType || formik2.values.hullType));
            dispatch(reservationActions.setPhone(formik2.values.phone));
            dispatch(reservationActions.setAddress(formik2.values.address));
            dispatch(reservationActions.setPostCode(formik2.values.postCode));
            dispatch(reservationActions.setCountry(formik.values.country || formik2.values.country));
            dispatch(reservationActions.setFirstName(formik2.values.firstName));
            dispatch(reservationActions.setLastName(formik2.values.lastName));
            dispatch(reservationActions.setNatureOfTravel(formik.values.natureOfTravel || formik2.values.natureOfTravel));
            dispatch(reservationActions.setRedeemNights(formik.values.nightsToRedeem || 0));
            if(formik.values.liveAboard !== undefined) dispatch(reservationActions.setLiveaboard(formik.values.liveAboard));
            if(formik2.values.liveAboard !== undefined) dispatch(reservationActions.setLiveaboard(formik2.values.liveAboard));
            if(formik2.values.waterElectricity !== undefined)  dispatch(reservationActions.setNeedWaterElectricity(formik2.values.waterElectricity));
            if(formik.values.passeportEscales !== undefined)  dispatch(reservationActions.setPasseportEscales(formik.values.passeportEscales));
            dispatch(reservationActions.sendBookingRequest(formik2.values.emailAddress));

    }

    const datesRangePicker = () => {

        return (<Section key="date-range-picker">
            <DateRangePicker
                placeholder={editEndDate && editStartDate ? t('ARRIVAL_DEPARTURE_PLACEHOLDER') : t('ARRIVAL')}
                limits={limits.pickerLimits}
                startDate={startDate ? moment(startDate) : null}
                endDate={endDate ? moment(endDate) : null}
                onDatesChange={onDatesChange}
                error={submitted && (!!formik.errors.startDate || !!formik.errors.endDate)}
                editEndDate={editEndDate}
                editStartDate={editStartDate}
                contract={contracts?.find(v => v.id === contract) || null}
                disabled={isReservationsDisabled}
            />
            {submitted && formik.errors.startDate &&
                <ErrorMessage className="error-message">{formik.errors.startDate}</ErrorMessage>}
            {submitted && !formik.errors.startDate && formik.errors.endDate &&
                <ErrorMessage className="error-message">{formik.errors.endDate}</ErrorMessage>}
        </Section>)
    };

    const getInput = (key,
                      title,
                      ref,
                      handler,
                      tooltip
    ) => <InputWrapper>
        <InputTitle><span>{t(title)}</span>
            {tooltip && <>
                <InfoSharpIcon style={{fontSize: 13, paddingLeft: 4}}/>
                <Tooltip className="tooltip">
                    <TooltipDesc> {t(tooltip)} </TooltipDesc>
                </Tooltip>
            </>}
        </InputTitle>

        <InputField
            id={key}
            inputRef={ref}
            type="number"
            value={`${formik.values[key] ?? ''}`}
            onChange={handler}
            handleBlur={formik.handleBlur}
            disabled={isReservationsDisabled}
            error={submitted && (!!formik.errors[key] && !!formik.touched[key])}
        />
        {submitted && formik.errors[key] && formik.touched[key] &&
            <ErrorMessage className="error-message">{formik.errors[key]}</ErrorMessage>}
    </InputWrapper>

    useEffect(() => {
        //do we need to have a flag that tells us its a booking request and not a regular reservation?
        // I think no need because the only way in this page to have such a reservation error is when sending a booking request
        if (boater && forceLogin && isRequest && reservationError === 'USER_ALREADY_EXISTS') {
            dispatch(reservationActions.setReservationError(undefined));
            sendBookingRequest();
        }
    }, [boater]);

    const handleMessageMarina = () => {
        if(loggedIn) {
            if (selectedBoaterVessel && isHomeMarina) {
                // if the marina is not Home for the selected vessel - select the vessel which belongs to this marina
                const vesselsVerifiedInThisMarina = vesselsWithHomeMarina.filter(
                    ({ home_marina_id }) => home_marina_id === marina.id
                );
                if (vesselsVerifiedInThisMarina.length) {
                    selectBoaterVessel(vesselsVerifiedInThisMarina[0].id);
                }
            }
            setTimeout(
                () => {
                    window.location.href = `${window.location.origin}/${i18n.language}/marina/${marina.id}${MESSAGES_PAGE}`;
                },
                400
            );
        } else {
            dispatch(reservationActions.setForceLogin(true));
        }
    }

    const onVesselSelect = vesselName => {
        if (vesselName === 'newBoat') {
            formik.setValues({
                ...formik.values,
                existingVesselName: vesselName,
                vesselName: undefined,
                vesselBeam:undefined,
                vesselLength: undefined,
                vesselDraft:undefined,
                vesselType:undefined,
                hullType:undefined,
                homeMarinaId: undefined

            })
            dispatch(reservationActions.setIsNewVessel(true))
            dispatch(reservationActions.setVessel(undefined))
            dispatch(reservationActions.setVesselName(undefined))

        } else {

            const selectedVessel = eligibleVesselsForMarina?.find((v) => v.name === vesselName);
            console.log("'selected vessel", selectedVessel);
            formik.setValues({
                ...formik.values,
                existingVesselName: vesselName,
                vesselName: vesselName,
                vesselType: selectedVessel?.type || undefined,
                hullType: selectedVessel?.hull_type || undefined,
                vesselLength: selectedVessel?.length,
                vesselBeam: selectedVessel?.beam,
                vesselDraft: selectedVessel?.draft,
                homeMarinaId: selectedVessel?.home_marina_id ? (selectedVessel?.home_marina_id)
                : selectedVessel?.home_marina_name? generateID(selectedVessel?.home_marina_name)
                : undefined

            });
            setEmptyFields({hull_type: !selectedVessel.hull_type , type: !selectedVessel.type});
            dispatch(reservationActions.setIsNewVessel(false))
            dispatch(reservationActions.setVessel(selectedVessel))
            dispatch(reservationActions.setVesselName(selectedVessel?.name));
            if(reservationError === 'RESERVATION_DUPLICATE_DATA'){
                dispatch(reservationActions.setReservationError(undefined));
            }
        }
        if (proposal) {
            dispatch(reservationActions.clearBerthLock(proposal));
            dispatch(reservationActions.setReservationProposal(undefined));
            formik2.resetForm();
        }
        if(calculatedPriceForOffline){
            dispatch(reservationActions.setCalculatedPrice(null));
        }
        setOffline(false);
        setTooLate(false);
        //should change this everywhere
    }

    const renderSelect = (
        label,
        hint,
        ref,
        key,
        onChange,
        options,
        disabled,
        tooltip,
        max_vessel_beam,
        max_vessel_draft,
        max_vessel_length
    ) => (<InputWrapper>
        <InputTitle><span>{t(label)}</span>
            {tooltip && <>
                <InfoSharpIcon style={{fontSize: 13, paddingLeft: 4}}/>
                <Tooltip className="tooltip">
                    <TooltipDesc> {t(tooltip, { max_beam:max_vessel_beam, max_draft:max_vessel_draft, max_length:max_vessel_length})} </TooltipDesc>
                </Tooltip>
            </>}
        </InputTitle>
        <Select
            inputRef={ref}
            value={formik.values[key]}
            options={options}
            onChange={onChange}
            error={submitted && !!formik.errors[key]}
            hint={t(hint)}
            disabled={disabled} />
        {submitted && formik.errors[key] && <ErrorMessage>{formik.errors[key]}</ErrorMessage>}
    </InputWrapper>);

    const handlers = useMemo(() => ({
        estimatePrice: () => {
            formik.submitForm();
            setFocusOnFirst(true);
        },
        checkAvailability: () => {
            formik.submitForm();
            setFocusOnFirst(true);
        },
        continueToBooking: next,
        sendBookingRequest: () => {
            formik2.submitForm()
            setBookingRequestSubmitted(true);
        }
    }), [next]);

    const button = useReservationInputsMainButton(
        isReservationsDisabled,
        tooLate,
        offline,
        proposal,
        calculatedPriceForOffline,
        isInstantBookingEnabled,
        formik.values.passeportEscales,
        handlers
    )

    return <>
        { isIframe && enableBackground && marinaData?.images && marinaData?.images.length > 0 && <>
            <BackgroundImage src={marinaData?.images[0].full}/>
            <BackgroundImageOverlay/>
        </>}
        <PageWrapper>
            <Card>
                <FormWrapper>
                    {isReservationsDisabled && <NoReservationHeader>
                        <InfoCircleFilled style={{ color: '#194AB9' }} />
                        {sanitizeTranslation(t('MARINA_DISABLED', {marina_name: marina.name}))}
                    </NoReservationHeader>}
                    {!isReservationsDisabled && <Title>{t('TITLE_BOOK_A_BERTH')}</Title>}
                </FormWrapper>
                {(!loggedIn && !isReservationsDisabled) && <LoginWrapper>
                    <Login/>
                </LoginWrapper>}
                <FormWrapper padTop={!loggedIn}>
                    <Subtitle>
                        {!!contracts.length
                            ? t('PERIOD_STAY') : t('SUBTITLE_DATES')}
                    </Subtitle>

                    {!!contracts.length && <Section padding>
                        <Select
                            key="period-select"
                            inputRef={contractIdRef}
                            value={contractId}
                            options={[
                                    ...(!!shortTermPlansLength ? [{ label: t("SHORT_TERM"), value: "SHORT_TERM" }] : []),
                                    ...(contracts?.map(period => ({
                                        label: period.name || period.contract_type,
                                        value: period.id
                                    })) || [])
                                ]}

                            disabled={isReservationsDisabled}
                            onChange={onPeriodChange}
                            hint={t('SELECT_PERIOD') || undefined}
                            error={submitted && !!formik.errors.contractId}
                        />
                        {submitted && formik.errors.contractId &&
                            <ErrorMessage className="error-message">{formik.errors.contractId}</ErrorMessage>}
                    </Section>

                    }
                    {( !contracts.length || periodSelected) && datesRangePicker()}

                    <Subtitle style={{marginTop: '30px'}}>{t('SUBTITLE_DIMENSIONS')}</Subtitle>
                    <InputsWrapper noMargins={!!proposal}>
                        { !!(eligibleVesselsForMarina && eligibleVesselsForMarina.length) &&
                        <Row style={{width: '100%'}}>
                            {renderSelect('BOAT', 'SELECT_BOAT', vesselRef, 'existingVesselName', onVesselSelect,
                                [
                                    ...(eligibleVesselsForMarina?.map(item => ({ label: item.name, value: item.name })) || []),
                                    { label: '+ Add new boat...', value: 'newBoat', isNewOption: true }
                                ]
                                ,isReservationsDisabled, 'ELIGIBLE_VESSEL_TOOLTIP', limits.vesselSizeLimits.max_vessel_beam, limits.vesselSizeLimits.max_vessel_draft, limits.vesselSizeLimits.max_vessel_length
                            )}
                        </Row>}
                        { <>
                        { isNewVessel && <SizeInputs>
                            {getInput('vesselLength', 'INPUT_TITLE_LENGTH', loaRef, onLengthChanged, 'LENGTH')}
                            {getInput('vesselBeam', 'INPUT_TITLE_BEAM', beamRef, onBeamChanged)}
                            {getInput('vesselDraft', 'INPUT_TITLE_DRAFT', draftRef, onDraftChanged)}
                        </SizeInputs>}
                        { (restrictions.vesselType &&  (isNewVessel || emptyFields.type )) &&
                            <Section>
                            <InputLabel>{t('BOAT_TYPE')}</InputLabel>
                                <Select
                                    key="boat-type-select"
                                    inputRef={vesselTypeRef}
                                    value={vesselType || null}
                                    disabled={isReservationsDisabled}
                                    options={Object.keys(VesselType).map(opt => ({label: t(opt), value: opt}))}
                                    onChange={onVesselTypeChange}
                                    hint={t('SELECT_BOAT_TYPE') || undefined}
                                    error={submitted && !!formik.errors.vesselType}
                                />
                                {submitted && formik.errors.vesselType &&
                                    <ErrorMessage className="error-message">{formik.errors.vesselType}</ErrorMessage>}
                            </Section>
                        }
                        {restrictions.hullType &&  (isNewVessel || emptyFields.hull_type)  &&
                            <Section>
                            <InputLabel>{t('HULL_TYPE')}</InputLabel>
                                <Select
                                    key="hull-type-select"
                                    inputRef={hullTypeRef}
                                    value={hullType || null}
                                    options={Object.keys(HullType).map(opt => ({label: t(opt), value: opt}))}
                                    onChange={onHullTypeChange}
                                    disabled={isReservationsDisabled}
                                    hint={t('SELECT_HULL_TYPE') || undefined}
                                    error={submitted && !!formik.errors.hullType}
                                />
                                {submitted && formik.errors.hullType &&
                                    <ErrorMessage className="error-message">{formik.errors.hullType}</ErrorMessage>}
                            </Section>
                        }
                        </>}
                        {restrictions?.homeMarina && <Row>
                        <InputWrapper>
                            <HomeMarinaSelect
                                formik={formik}
                                selectedVessel={selectedVessel}
                                submitted={submitted}
                            />
                            {submitted && formik.errors.homeMarinaId && <ErrorMessage>{formik.errors.homeMarinaId}</ErrorMessage>}
                        </InputWrapper></Row>}
                        {restrictions?.country && <Row>
                            {renderSelect('COUNTRY', 'SELECT_COUNTRY', countryRef, 'country', onCountryChange, countries)}
                            </Row>}
                        {restrictions.natureOfTravel &&
                            <Section>
                            <InputLabel>{t('BOAT_USAGE')}</InputLabel>
                                <Select
                                    key="not-select"
                                    inputRef={notRef}
                                    disabled={isReservationsDisabled}
                                    value={formik.values.natureOfTravel || null}
                                    options={Object.keys(NatureOfTravel).map(opt => ({label: t(opt), value: opt}))}
                                    onChange={onNatureOfTravelChange}
                                    hint={t('SELECT_NATURE_OF_TRAVEL') || undefined}
                                    error={submitted && !!formik.errors.natureOfTravel}
                                />
                                {submitted && formik.errors.natureOfTravel &&
                                    <ErrorMessage
                                        className="error-message">{formik.errors.natureOfTravel}</ErrorMessage>}
                            </Section>
                        }
                        {restrictions.liveAboard &&
                            <Section>
                                <div style={{display: 'flex'}}>
                                    <input disabled={isReservationsDisabled} type="checkbox" checked={formik.values.liveAboard}
                                           onChange={onLiveAboardChange}/>
                                    <span style={{marginLeft: '5px'}}> {t("LIVEABOARD")} </span>
                                </div>
                            </Section>
                        }
                        {restrictions.waterElectricity &&
                            <Section>
                                <div style={{display: 'flex'}}>
                                    <input disabled={isReservationsDisabled} type="checkbox" checked={formik.values.waterElectricity}
                                           onChange={onWaterElectricityChanged}/>
                                    <span style={{marginLeft: '5px'}}>{t('NEED_WATER_AND_ELECTRICITY')}</span>
                                </div>
                            </Section>
                        }
                        {restrictions.passeportEscales &&
                            <Section>
                                <div style={{display: 'flex'}}>
                                    <input disabled={isReservationsDisabled} type="checkbox"
                                           checked={formik.values.passeportEscales}
                                           onChange={onPasseportEscalesChanged}/>
                                    <span style={{marginLeft: '5px'}}>{t('I_AM_PASSEPORT_ESCALES_MEMBER')}</span>
                                </div>
                            </Section>
                        }
                        {!!isTEMMarina && isTEMConnected && !!proposal?.cannot_be_booked_instantly && <Row>
                            {!isEmpty(calculatedPrice) && calculatedPrice.max_nights_to_redeem === 0 && (
                                    <RedeemNightsExceeded>
                                        {t('ALL_NIGHTS_WERE_REDEEMED')}
                                    </RedeemNightsExceeded>
                                )}
                            {!isEmpty(calculatedPrice) && calculatedPrice.max_nights_to_redeem > 0 &&
                                renderSelect('RESERVATION_WIDGET_REDEEM', 'RESERVATION_WIDGET_REDEEM', redeemNightsRef,
                                'nightsToRedeem', onRedeemNightsChange, redeemNightsOptions)}
                        </Row>}
                    </InputsWrapper>
                    <AvailableBerthsBox
                        mode={button?.mode || 'NONE'}
                        proposal={proposal}
                        marina={marina}
                        isLoggedIn={loggedIn}
                        errors={{email: emailTouched && emailError, boatName: boatNameTouched && !boatName}}
                        tooLate={tooLate}
                        sizeLimit={ (proposal?.cannot_be_booked_instantly && proposal.exceeds_marina_reservation_limits)}
                        diff={formik.values.startDate ? moment(formik.values.startDate).startOf('day').diff(moment().startOf('day'), 'days') : undefined}
                        daysInAdvance={limits.pickerLimits.min_days_before || undefined}
                        offline={ !isInstantBookingEnabled || offline}
                        calculatedPrice={calculatedPriceForOffline}
                        passeportEscales={formik.values.passeportEscales}
                        isInstantBookingDisabled={ !isInstantBookingEnabled || (proposal?.cannot_be_booked_instantly && !proposal.exceeds_marina_reservation_limits) }
                        isNewVessel = { isNewVessel}
                        requirements_before_approval = {requirements_before_approval}
                        formik = { formik2 }
                        bookingRequestSubmitted={bookingRequestSubmitted}
                    />
                    {
                        button && <MainButton
                            label={t(button.mode)}
                            onClick={button.handler}
                        />
                    }
                    {isReservationsDisabled && <StillInterested>
                        {t('RESERVATION_WIDGET_STILL_INTERESTED')}
                        <div
                            aria-disabled
                            className='message-link-reservation'
                            onClick={handleMessageMarina}
                        >
                            <ReactSVG
                                className='message-icon'
                                style={{lineHeight: 2}}
                                src={messageIcon}
                            />
                            {t('MESSAGE_TO_MARINA')}
                        </div>
                    </StillInterested>
                    }
                    { !isMobile && <PoweredByPickapier/> }
                </FormWrapper>
                { isInstantBookingEnabled && <InstantBookingSideStamp/> }
                { isMobile && <PoweredByPickapier/> }
            </Card>
        </PageWrapper>
        <ReservationSuccessDialog
            open={!!reservationDetails && !!reservationDetails && isRequest}
            redirectUrl={redirectUrlProvided || !reservationDetails ? (redirectUrl || window.location.origin) : `${window.location.origin}/${i18n.language}/reservation/${reservationDetails.id}`}
            onClose={() =>{
                        dispatch(reservationActions.clear());
                    }}
        />
        <ReservationFailureDialog
                    open={reservationError === 'RESERVATION_DUPLICATE_DATA'}
                    onClose={() => {
                        dispatch(reservationActions.setReservationError(undefined));
                                    }}
                    redirectUrl={ '#'}
                    labels={{Subtitle: 'Reservation Conflict!', Text1: " It appears there's a scheduling conflict for the dates you've chosen.", Text2:" Please consider adjusting your reservation dates or review your existing bookings under 'My Trips'. ", onClose: 'Try other dates'} }
                />
        <LoginDialog
            open={forceLogin && !loggedIn}
            force={forceLogin && !loggedIn}
            onClose={() => {
                dispatch(reservationActions.setForceLogin(false))
            }}
            email={email}
        />
        <SessionEndedDialog
            open={expired}
            onClose={() => {
                formik.resetForm();
                setExpired(false);
            }}
            onRecheck={() => {
                dispatch(reservationActions.clearBerthLock());
                formik.submitForm();
                setExpired(false);
                setFocusOnFirst(true);

            }}/>
    </>;
}

export default ReservationInputs;
